// http://z.maxpreps.com/feeds/json/concordia_rewrite_mappings.ashx

// server copy of @maxpreps/apiserviceclients/apiModels/ScheduleModel
const ScheduleModel = {
  Standard: 0,
  Custom: 1,
  Limited: 2
};

const ALL_SPORT_SEASONS = [
  {
    allSeasonId: 'f237cf95-dad9-4dce-bdfc-77ad379d8f3c',
    genderSportId: 'boys,badminton',
    gender: 'Boys',
    sport: 'Badminton',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '94f7be29-2062-4d80-8064-3e8d89a3c54d',
    genderSportId: 'boys,baseball',
    gender: 'Boys',
    sport: 'Baseball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '74b71345-eab6-4806-bfeb-396803aaa11c',
    genderSportId: 'boys,bowling',
    gender: 'Boys',
    sport: 'Bowling',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'a1e42dfc-de59-4d55-8a25-574fc7e0bb49',
    genderSportId: 'boys,flagfootball',
    gender: 'Boys',
    sport: 'Flag Football',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '73038899-9124-4b1c-8d8b-26c8a0589ac6',
    genderSportId: 'boys,golf',
    gender: 'Boys',
    sport: 'Golf',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '1b43d378-4cbe-47af-85d7-a4dd3141ca4b',
    genderSportId: 'boys,gymnastics',
    gender: 'Boys',
    sport: 'Gymnastics',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '0029f933-2171-4ba3-855a-36d53cfc5ac9',
    genderSportId: 'boys,judo',
    gender: 'Boys',
    sport: 'Judo',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '522dfcf5-ce2b-4f59-901d-8d46ab6f5683',
    genderSportId: 'boys,lacrosse',
    gender: 'Boys',
    sport: 'Lacrosse',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '348c60ce-7c31-43d8-868d-7d696608fe51',
    genderSportId: 'boys,rugby',
    gender: 'Boys',
    sport: 'Rugby',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'aba295df-5358-4a8b-b664-5db2552cad87',
    genderSportId: 'boys,soccer',
    gender: 'Boys',
    sport: 'Soccer',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'fb6d6917-8d46-47be-9e3e-52ce58197960',
    genderSportId: 'boys,swimming',
    gender: 'Boys',
    sport: 'Swimming',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: 'e6fc52ec-0c90-4628-b4de-a2cbe3bbcb05',
    genderSportId: 'boys,tennis',
    gender: 'Boys',
    sport: 'Tennis',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: 'ec7a8aa9-356a-445f-9cb4-dc2274d89242',
    genderSportId: 'boys,trackfield',
    gender: 'Boys',
    sport: 'Track & Field',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '20384960-50cd-4636-a5a4-cdfbf89db879',
    genderSportId: 'boys,volleyball',
    gender: 'Boys',
    sport: 'Volleyball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '2e5340f1-e450-4911-a4f1-7dabed8fb435',
    genderSportId: 'boys,waterpolo',
    gender: 'Boys',
    sport: 'Water Polo',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '899e1b5c-a186-4679-8956-51ca253cf646',
    genderSportId: 'boys,weightlifting',
    gender: 'Boys',
    sport: 'Weight Lifting',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'b93b1368-889f-4364-81c3-8e603c312590',
    genderSportId: 'boys,wheelchairsports',
    gender: 'Boys',
    sport: 'Wheelchair Sports',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'afbdcf59-6a29-41e6-ae1b-2cd8fd4266f3',
    genderSportId: 'co-ed,archery',
    gender: 'Co-ed',
    sport: 'Archery',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '2b5fd5d4-c818-4b3e-82d8-401a814e3e07',
    genderSportId: 'co-ed,bassfishing',
    gender: 'Co-ed',
    sport: 'Bass Fishing',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '568992b9-cbba-4969-8d14-2724a22d468c',
    genderSportId: 'co-ed,cricket',
    gender: 'Co-ed',
    sport: 'Cricket',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'a278510b-d654-4f78-a572-df2894ce74c7',
    genderSportId: 'girls,badminton',
    gender: 'Girls',
    sport: 'Badminton',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '9449b0c1-9d44-4e16-913d-bc939dde169b',
    genderSportId: 'girls,bowling',
    gender: 'Girls',
    sport: 'Bowling',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '07638f86-cb6d-4c93-abaa-d6b66dcb60ec',
    genderSportId: 'girls,flagfootball',
    gender: 'Girls',
    sport: 'Flag Football',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '069f6298-58ba-4b1d-ad4a-9560a2e93276',
    genderSportId: 'girls,golf',
    gender: 'Girls',
    sport: 'Golf',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: 'f088d76c-0fa7-4a04-badf-2e50a52450de',
    genderSportId: 'girls,gymnastics',
    gender: 'Girls',
    sport: 'Gymnastics',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '3b55bbf1-b259-4021-bb84-9a219b54ab88',
    genderSportId: 'girls,judo',
    gender: 'Girls',
    sport: 'Judo',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '09b97358-d111-4b16-9cd3-b95b169386f3',
    genderSportId: 'girls,lacrosse',
    gender: 'Girls',
    sport: 'Lacrosse',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'baa7b750-0cca-493c-b99b-899577cb3462',
    genderSportId: 'girls,rugby',
    gender: 'Girls',
    sport: 'Rugby',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '39cbbd00-cd62-4a99-a31c-83d4ccdb8fa1',
    genderSportId: 'girls,beachvolleyball',
    gender: 'Girls',
    sport: 'Beach Volleyball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'c635e16b-4ed3-43f7-8133-051387af1ffb',
    genderSportId: 'girls,slowpitchsoftball',
    gender: 'Girls',
    sport: 'Slow Pitch Softball',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'eafa3987-6f30-4e48-aa24-8c665225333b',
    genderSportId: 'girls,soccer',
    gender: 'Girls',
    sport: 'Soccer',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '53b3ee46-165a-4fb7-bb1a-4fcf915c2763',
    genderSportId: 'girls,softball',
    gender: 'Girls',
    sport: 'Softball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '79ada089-9254-4377-ae0b-045f9b83632e',
    genderSportId: 'girls,swimming',
    gender: 'Girls',
    sport: 'Swimming',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '9637a622-7723-43ec-8a7b-49c0b0c8015d',
    genderSportId: 'girls,tennis',
    gender: 'Girls',
    sport: 'Tennis',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '59c448f6-470e-4d51-aaa0-7fe318730b4f',
    genderSportId: 'girls,trackfield',
    gender: 'Girls',
    sport: 'Track & Field',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: 'f659e3c4-794a-4331-a827-2b35bb285e12',
    genderSportId: 'girls,waterpolo',
    gender: 'Girls',
    sport: 'Water Polo',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'aee447c3-c368-4656-971f-b53f2b5341d5',
    genderSportId: 'girls,weightlifting',
    gender: 'Girls',
    sport: 'Weight Lifting',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '2c121a6a-7274-4744-87f1-660f8ab0019d',
    genderSportId: 'girls,wheelchairsports',
    gender: 'Girls',
    sport: 'Wheelchair Sports',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'a42c7ea4-0907-491e-b56f-a2d31a45bf19',
    genderSportId: 'boys,basketball',
    gender: 'Boys',
    sport: 'Basketball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'e1a6b9cf-ef0f-47cd-a531-6ac2d6b43689',
    genderSportId: 'boys,fencing',
    gender: 'Boys',
    sport: 'Fencing',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '90ebf915-7090-4503-9038-c19c9a256491',
    genderSportId: 'boys,icehockey',
    gender: 'Boys',
    sport: 'Ice Hockey',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '3cf1409e-9d33-4f17-97f7-c8e8523f1cec',
    genderSportId: 'boys,indoortrackfield',
    gender: 'Boys',
    sport: 'Indoor Track & Field',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '127379bf-a596-4df3-baa5-7014af9f298e',
    genderSportId: 'boys,skisnowboard',
    gender: 'Boys',
    sport: 'Ski & Snowboard',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '7a2d0490-2c4b-4509-8d8a-1a2809d5432a',
    genderSportId: 'boys,wrestling',
    gender: 'Boys',
    sport: 'Wrestling',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '6c6fd8d8-4edf-44d5-920b-a206186be6e6',
    genderSportId: 'co-ed,canoepaddling',
    gender: 'Co-ed',
    sport: 'Canoe Paddling',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '81a6eff5-64af-4a2e-a2f4-834484dd5ddc',
    genderSportId: 'co-ed,cheer',
    gender: 'Co-ed',
    sport: 'Cheer',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'b912fca0-13c1-4a1b-97d5-f1c5b526b548',
    genderSportId: 'co-ed,danceteam',
    gender: 'Co-ed',
    sport: 'Dance Team',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '5ab34962-9a09-4025-b8f1-3cfd2646f1c9',
    genderSportId: 'co-ed,drill',
    gender: 'Co-ed',
    sport: 'Drill',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '22a1a215-460c-4805-abb1-672f0c25941b',
    genderSportId: 'co-ed,speech',
    gender: 'Co-ed',
    sport: 'Speech',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '81d2a4ab-cd12-46ac-9ead-f00c1c49206b',
    genderSportId: 'girls,basketball',
    gender: 'Girls',
    sport: 'Basketball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '1c2e7194-49c2-4ef8-9121-a38042f8fa66',
    genderSportId: 'girls,fencing',
    gender: 'Girls',
    sport: 'Fencing',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'bfacc9ec-145e-4659-ba7e-0824d163d5fc',
    genderSportId: 'girls,fieldhockey',
    gender: 'Girls',
    sport: 'Field Hockey',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'e8a468fa-d605-4b34-80b2-32c1f5f30fd8',
    genderSportId: 'girls,icehockey',
    gender: 'Girls',
    sport: 'Ice Hockey',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '3c31dc18-1064-42c3-b2cb-44548d0466d2',
    genderSportId: 'girls,indoortrackfield',
    gender: 'Girls',
    sport: 'Indoor Track & Field',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '6b8a5c08-0fe3-471f-8001-42c14bac694f',
    genderSportId: 'girls,skisnowboard',
    gender: 'Girls',
    sport: 'Ski & Snowboard',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '2059473e-9a9c-400b-b1e2-9a119e64e597',
    genderSportId: 'girls,volleyball',
    gender: 'Girls',
    sport: 'Volleyball',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: 'ffddbc40-27ca-4b62-97b2-7c72af019807',
    genderSportId: 'girls,wrestling',
    gender: 'Girls',
    sport: 'Wrestling',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '917605c1-a7e7-4322-9cc0-826f354c9d9c',
    genderSportId: 'boys,crosscountry',
    gender: 'Boys',
    sport: 'Cross Country',
    scheduleModel: ScheduleModel.Custom
  },
  {
    allSeasonId: '22e2b335-334e-4d4d-9f67-a0f716bb1ccd',
    genderSportId: 'boys,football',
    gender: 'Boys',
    sport: 'Football',
    scheduleModel: ScheduleModel.Standard
  },
  {
    allSeasonId: '41c5228b-e908-4064-8424-507e2695fa5e',
    genderSportId: 'co-ed,badminton',
    gender: 'Co-ed',
    sport: 'Badminton',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '2497cafc-e282-4b67-8445-3c28eb2e7e86',
    genderSportId: 'co-ed,poms',
    gender: 'Co-ed',
    sport: 'Poms',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: '1c21969f-24e7-474d-abc6-5ffd5bcefdc9',
    genderSportId: 'co-ed,riflery',
    gender: 'Co-ed',
    sport: 'Riflery',
    scheduleModel: ScheduleModel.Limited
  },
  {
    allSeasonId: 'ea0288cf-f517-4c2c-9810-5c8dbeff8e7f',
    genderSportId: 'girls,crosscountry',
    gender: 'Girls',
    sport: 'Cross Country',
    scheduleModel: ScheduleModel.Custom
  }
];

module.exports = {
  ALL_SPORT_SEASONS,
  findAllSportSeasonById: id =>
    ALL_SPORT_SEASONS.find(i => i.allSeasonId === id)
};
